import {createContext} from "react";

export const StoryContext = createContext(null);

export const WORLD_BEHAVIOUR = -1;
export const WORLD_BLENDED = 0;
export const WORLD_COMPARABLE = 1;
